import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Asset } from 'src/app/interfaces/asset';

@Component({
  selector: 'app-rate-dialog',
  templateUrl: './rate-dialog.component.html',
  styleUrls: ['./rate-dialog.component.less']
})
export class RateDialogComponent {
  rate;
  constructor(public dialogRef: MatDialogRef<RateDialogComponent>, @Inject(MAT_DIALOG_DATA) public details: Asset) {
    this.rate = this.details.myRating ? this.details.myRating : 0;
  }

  /** Sumbit rate action */
  public submitRate() {
    this.dialogRef.close(this.rate);
  }
}